<template>
	<div>
		<!-- <el-dialog title="提示" :visible="NOTLINKEDSTATUS1" width="500px" :show-close="false" :close-on-click-modal="false"> -->
		<el-dialog title="提示" :visible="NOTLINKEDSTATUS" width="500px"  @close="$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false})">
			<div class="tip flexJA flexFs">
				<img src="@/assets/images/mid.png">
				<div>
					<div style="font-size: 14px;color: #fff;line-height: 30px;">检测到升级中断</div>
					<div>请插入耳机后，点击确认恢复升级。若不能继续升级请重启电脑后再试。</div>
				</div>
			</div>
			<div class="btns flexJA flexFe">
				<!-- <div class="checkbox flexJA" :class="{checked: prompts}" @click="prompts = !prompts">
					<img src="@/assets/images/39.png" v-show="!prompts">
					<img src="@/assets/images/40.png" v-show="prompts">
					不再提示
				</div> -->
				<div class="btn btn-1 flexJA" @click="confirm">确认</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import { Loading } from 'element-ui';
	export default {
		data() {
			return {
				num: 0,
				times: null,
				elLoading: null,
				Progress: 0,
				prompts: false,
			}
		},
		computed: {
			...mapState({
				NOTLINKEDSTATUS: (state) => state.NOTLINKEDSTATUS,
				NOTLINKEDSTATUS1: (state) => state.NOTLINKEDSTATUS1,
			}),
		},
		methods: {
			confirm() {
				this.$store.commit('setUpgrade', {status: true, progress: this.NOTLINKEDSTATUS1 ? 0.1 : 0, dialogStatus: true, type: 1});
				this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false});
				// this.elLoading = this.$loading({
				// 	lock: true,
				// 	text: '检测升级进度...',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(0, 0, 0, 1)'
				// });
				// window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
				// 	this.Progress = res.msg;
				// 	console.log('第一次进度：', this.Progress)
				// 	if(res.msg != 100) {
				// 		this.times = setInterval(e=>{
				// 			this.GetProgress();
				// 		}, 1000)
				// 	}else {
				// 		console.log('进度为100，就不弹出升级界面面了')
				// 		localStorage.removeItem('UpgradeData');
				// 		this.elLoading && this.elLoading.close();
				// 		this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false});
				// 		// this.$message({ message: '已升级成功！', type: 'success' });
				// 		this.$store.commit('setUpgrade', {status: true, progress: 100, dialogStatus: true, type: 3});
				// 	}
				// })
			},
			
			GetProgress() {
				window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
					let Progress = this.Progress;
					console.log('第二次进度：', res.msg)
					clearInterval(this.times)
					this.elLoading && this.elLoading.close();
					this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: false});
					if(res.msg == 100) {
						console.log('进度为100，就不弹出升级界面面了')
						localStorage.removeItem('UpgradeData')
						this.$store.commit('setUpgrade', {status: true, progress: 100, dialogStatus: true, type: 3});
					}else {
						console.log('第一次获取进度：', Progress, '第二次获取进度：', res.msg )
						if(res.msg == Progress) {
							console.log('进度<100，隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级')
							// 进度<100，就间隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级。
							this.$store.commit('setUpgrade', {status: true, progress: 0, dialogStatus: true, type: 1});
						}else {
							console.log('进度<100，如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。')
							// 如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。
							this.$store.commit('setUpgrade', {status: true, progress: res.msg, dialogStatus: true, type: 1});
						}
					}
				}).catch(err => {
					console.error('IAPBurner.dll[GetProgress]: ', err)
					setTimeout(e=>{
						this.GetProgress();
					},100)
				});
			},
			GetDeviceStatus() {
				window.LZPlugin.nativeCall("LenovoHeadset.dll","GetDeviceStatus",null).then(res=>{
					console.log('LenovoHeadset.dll[GetDeviceStatus]: ', res);
					this.num = this.num + 1;
					if(res.msg == "AT_DEVICE_LINKED") {
						if(this.num > 2) {
							clearInterval(this.times)
							this.elLoading && this.elLoading.close();
							this.GetProgress();
						}
					}else {
						console.log(this.num)
						if(this.num > 10) {
							clearInterval(this.times)
							this.num = 0;
							this.elLoading && this.elLoading.close();
							this.$message({ message: '设备未连接', type: 'warning' });
						}
					}
				})
				
			},
		}
	}
</script>

<style scoped lang="scss">
	@import '@/assets/css/deep.scss';
	
	.checkbox {
		color: rgba(234, 247, 255, 0.6);
		font-size: 14px;
		cursor: pointer;
		
		img {
			width: 18px;
			height: 18px;
			margin-right: 10px;
		}
	}
	
	.checkbox.checkde {
		color: rgba(234, 247, 255, 0.6);
	}
</style>